<template>
  <div class="container page" style="width: 100%;">
    <van-nav-bar :title="$t('my.task_record')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="main">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty v-if="list.length === 0" :description="$t('withdraw.empty_data')" />

        <div v-else class="item_list" v-for="(v, key) in list" :key="key">
          <div class="lottery_info">
            <span class="period-number">{{ v.expect }}</span>
            <span class="period-number">{{ v.name }}</span>
          </div>

          <div class="recent">
            <div class="result-container">
              <span class="result-label">{{ $t("reservation.result") }}</span>
              <div class="badges-wrapper">
                <span class="ressquareBox">{{ v.size }}</span>
                <span class="ressquareBox">{{ v.double }}</span>
              </div>
            </div>
          </div>

          <div class="topInfo">
            <span v-if="v.status === 1" style="color: #07c160">{{ v.status_text }}</span>
            <span v-else>{{ v.status_text }}</span>
            <span class="money-text">{{ $t("reservation.money") }}：{{ v.money }}</span>
          </div>
          <div class="time">
            <span>{{ $t("reservation.order_time") }}：{{ v.create_time }}</span>
          </div>
          <div class="time">
            <span>{{ $t("reservation.settle_time") }}：{{ v.update_time }}</span>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list: [],
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
        this.getUserGameList();
      }, 500);
    },
    getUserGameList() {
      this.$http({
        method: 'get',
        url: 'user_get_game_list'
      }).then(res => {
        if (res.code === 200) {
          const lanng = localStorage.getItem("lang");
          this.list = res.data.map(item => {
            const opencode = item.opencode || [0, 0, 0];
            const sum = Number(opencode[0]) + Number(opencode[1]) + Number(opencode[2]);

            let size = '';
            let double = '';

            if (sum >= 11 && sum <= 18) {
              size = (lanng === 'zh' ? '玫瑰' : 'Roses');
            } else if (sum >= 3 && sum <= 10) {
              size = (lanng === 'zh' ? '百合' : 'Lis');
            }

            if (sum % 2 === 0) {
              double = (lanng === 'zh' ? '氣球' : 'Balloon');
            } else {
              double = (lanng === 'zh' ? '煙花' : 'Anneau');
            }

            return { ...item, size, double };
          });
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' })
    } else {
      this.getUserGameList();
    }
  },
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}

.container .main {
  position: relative;
  overflow: auto;
  background-color: #f2f2f5;
  height: 100%;
  padding: 0 10px;
}

.item_list {
  padding: 15px 15px;
  margin: 30px 10px;
  background: #fff;
  border-radius: 10px;
  line-height: 60px;
}

.item_list .topInfo span {
  flex: 1;
  font-size: 32px;
  font-weight: 700;
  color: #000;
}

.item_list .money-text {
  margin-left: 20px;
}

.item_list .time span {
  flex: 1;
  font-size: 25px;
  font-weight: 500;
  color: #000;
}

.item_list .period-number {
  margin-left: 20px;
  margin-right: 10px;
  font-size: 35px;
  font-weight: 700;
  color: #000;
}

.item_list .lottery_info {
  display: flex;
}

/* 修复后的布局样式 */
.recent {
  display: flex;
  align-items: center;
  padding: 10px 0;
}

.result-container {
  display: flex;
  align-items: center;
}

.result-label {
  font-size: 28px;
  color: #333;
  margin-right: 15px;
  font-weight: 500;
}

.badges-wrapper {
  display: flex;
  align-items: center;
}

.ressquareBox {
  background: linear-gradient(90deg, #f560cd, #4f2b8a);
  color: #fff;
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  border-radius: 12px;
  margin-right: 15px;
  padding: 6px 20px;
  min-width: 80px;
  display: inline-block;
}
</style>